import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { saveNextPath as saveNextPathAction } from './modules/Auth/AuthActions';
import { getProfile, isLoggedIn } from './modules/Auth/AuthReducer';

function Authenticated({ loggedIn, user, saveNextPath }) {
  const nextPath = useLocation().pathname;
  const navigate = useNavigate();

  useEffect(() => {
    if (!loggedIn) {
      saveNextPath(nextPath);
    } else if (!user?.email_verified && nextPath !== '/verify-email') {
      navigate('/verify-email-resend');
    }
  }, [loggedIn, navigate, nextPath, saveNextPath, user?.email_verified]);

  if (loggedIn) {
    return <Outlet />;
  }
  return <Navigate to="/login" />;
}

Authenticated.defaultProps = {
  user: {},
};

Authenticated.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  user: PropTypes.object,
  saveNextPath: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    loggedIn: isLoggedIn(state),
    user: getProfile(state),
  };
};

const mapDispatchToProps = dispatch => ({
  saveNextPath(nextPath) {
    dispatch(saveNextPathAction(nextPath));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Authenticated);
